import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const bonuses = [{
  num: '01',
  image: 'https://cdn.magicpatterns.com/uploads/vs1cLNWUefaKQFBPoh2gmJ/BONO_1.png',
  title: 'Mapa del Trauma Invisible',
  subtitle: 'Identifica el imán emocional que ordena tu realidad en piloto automático',
  description: 'Este mapa te ayuda a identificar la carga emocional dominante que sigue organizando tu vida desde las sombras.',
  originalPrice: '$19.00'
}, {
  num: '02',
  image: 'https://cdn.magicpatterns.com/uploads/7JirrqevsGxjm8RAkDttx3/BONO_2.png',
  title: 'Guía Express del Punto Cero',
  subtitle: 'El acceso rápido al estado donde deja de mandar tu patrón',
  description: 'Un protocolo vivo para entrar en neutralidad real en minutos — sin evasión, sin resignación. Solo claridad.',
  originalPrice: '$24.00'
}, {
  num: '03',
  image: 'https://cdn.magicpatterns.com/uploads/2EYak8zcCr8EzMW7Gw44Yy/BONO_3.png',
  title: 'Checklist de la Nueva Identidad',
  subtitle: 'La guía diaria para no volver a actuar como quien ya dejaste de ser',
  description: 'Una herramienta operativa para convertir tu transformación interna en elecciones concretas y sostenidas.',
  originalPrice: '$17.00'
}];
export function BonusSection() {
  const revealRef = useScrollReveal();
  return <section className="relative bg-brand-dark bg-grain py-[60px] md:py-[100px] px-[5%] overflow-hidden" data-id="element-24">
      <div className="absolute top-0 right-1/4 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,_rgba(201,169,110,0.08)_0%,_transparent_60%)] pointer-events-none z-0" data-id="element-25" />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.08)_0%,_transparent_60%)] pointer-events-none z-0" data-id="element-26" />

      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 reveal" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-29">
            BONOS INCLUIDOS
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-cream leading-tight mb-4" data-id="element-30">
            3 regalos que llevan tu transformación al siguiente nivel
          </h2>
          <p className="font-body text-[16px] text-brand-cream/60 max-w-xl mx-auto" data-id="element-31">
            Incluidos gratis por tiempo limitado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-32">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white/[0.04] border border-brand-gold/25 rounded-[20px] p-[32px] flex flex-col transition-all duration-300 hover:-translate-y-[6px] hover:border-brand-gold/50 hover:shadow-[0_20px_40px_rgba(201,169,110,0.1)] relative overflow-hidden" data-id="element-33">
              <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-brand-violet to-brand-gold" data-id="element-34" />

              <div className="font-body text-[11px] tracking-[0.15em] uppercase text-brand-gold mb-4" data-id="element-35">
                BONO {bonus.num}
              </div>

              <div className="w-full aspect-[4/3] rounded-[12px] overflow-hidden mb-6" data-id="element-36">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-37" />
              </div>

              <h3 className="font-display italic text-[24px] text-brand-cream mb-2" data-id="element-38">
                {bonus.title}
              </h3>

              <p className="font-body italic text-[13px] text-brand-gold/80 mb-4" data-id="element-39">
                {bonus.subtitle}
              </p>

              <p className="font-body text-[14px] text-brand-cream/60 leading-[1.7] mb-8 flex-grow" data-id="element-40">
                {bonus.description}
              </p>

              <div className="border-t border-white/[0.08] pt-5 mt-auto" data-id="element-41">
                <div className="flex items-baseline gap-3" data-id="element-42">
                  <span className="font-body text-[14px] text-brand-cream/40 line-through" data-id="element-43">
                    Valor: {bonus.originalPrice}
                  </span>
                  <span className="font-display text-[32px] text-brand-gold leading-none" data-id="element-44">
                    $0.00
                  </span>
                </div>
                <div className="font-display italic text-[14px] text-brand-gold mt-2" data-id="element-45">
                  GRATIS
                </div>
              </div>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-r from-brand-violet/10 to-brand-gold/10 border border-brand-gold/40 rounded-[16px] py-8 px-8 text-center transition-all duration-300 hover:border-brand-gold/60" data-id="element-46">
          <div className="font-body text-[15px] text-brand-cream/50 line-through mb-2" data-id="element-47">
            Valor total de los bonos: $60.00
          </div>
          <div className="font-display italic text-[clamp(28px,4vw,36px)] text-brand-gold leading-tight" data-id="element-48">
            Incluidos GRATIS con tu compra hoy
          </div>
        </div>
      </div>
    </section>;
}